module.exports = __webpack_public_path__ + "static/img/WILL-MCCABE.f12af2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILL-MCCABE.jpg
// module id = s96X
// module chunks = 0